import { axiosi } from "../../config/axios";

export const fetchAllBrands=async()=>{
    try {
        const res=await axiosi.get("/brands")
        return res.data
    } catch (error) {
        throw error.response.data
    }
}

export const createBrand = async (data, token) => {
    try {
        const config = token
            ? { headers: { Authorization: `Bearer ${token}` } }
            : {}
        const res = await axiosi.post("/brands", data, config);
        return res.data;
    } catch (error) {
        throw (error.response && error.response.data) || error;
    }
};
